module.exports = __webpack_public_path__ + "img/osszsuly.20c41953.svg";